import { render, staticRenderFns } from "./SelectAlias.vue?vue&type=template&id=47e9c18d&scoped=true&"
import script from "./SelectAlias.vue?vue&type=script&lang=js&"
export * from "./SelectAlias.vue?vue&type=script&lang=js&"
import style0 from "./SelectAlias.vue?vue&type=style&index=0&id=47e9c18d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9c18d",
  null
  
)

export default component.exports